import * as React from "react";
import "../styles/css/main.css";
const fikafyapp = require("../images/fikafy_how_it_works.png");
const downloadfikafy = require("../images/download-fikafy.svg");
// const background = require("../images/fikafy-background.jpg");

class LandingPageComponent extends React.Component {
  render(): JSX.Element {
    return (
      <div className="LandingPageComponent">
        {/* <div 
          className="fikafy-background-image" 
          style={{
            backgroundImage: `url(${background})`,
          }}
        >
          <div className="shader" />
        </div> */}
        <div className="fikafy-title-container">
          <p className="title">Find</p>
          <p className="title">Like-Minded</p>
          <p className="title">Nearby</p>
          <div className="subtitle-container">
            <p className="subtitle">Have Fika(Coffee). Live the moment.</p>
          </div>
          <div className="download-fikafy-container">
            <a href="https://apps.apple.com/app/fikafy-meet-professionals/id1513222552?l=en" target="_blank">
              <img className="download-fikafy" src={downloadfikafy} />
            </a>
          </div>
        </div>
        <div className="fikafy-app">
          <img src={fikafyapp} />
        </div>
      </div>
    );
  }
}

export default LandingPageComponent;



// WEBPACK FOOTER //
// ./src/components/landingpage.component.tsx